
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons'

export default {
  name: 'TextArea',

  props: {
    value: {
      type: [String, Number],
      default: null
    },

    placeholder: {
      type: String,
      default: null
    },

    rows: {
      type: Number,
      default: 3
    },

    maxLength: {
      type: Number,
      default: null
    },

    isDisabled: {
      type: Boolean,
      default: false
    },

    isReadOnly: {
      type: Boolean,
      default: false
    },

    inputClass: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      faExclamationCircle
    }
  },

  computed: {
    compValue: {
      set(newValue) {
        this.$emit('input', newValue)
      },

      get() {
        return this.value
      }
    }
  }
}
